import React from 'react';
import PropTypes from 'prop-types';
import withScopedTranslations from '../../../../../withScopedTranslations/withScopedTranslations';
import DetailsBox from './DetailsBox';
import { createUseStyles } from 'react-jss';

const DetailsCondition = ({ details, }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.detailsBoxWrapper}>
        {details.map((detailsProps) => (
          <DetailsBox
            key={detailsProps.label}
            {...detailsProps}
          />
        ))}
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  detailsBoxWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  container: {
    paddingBottom: '40px',
    marginTop: '40px',
    overflow: 'hidden',
  },
})

DetailsCondition.propTypes = {
  details: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    score: PropTypes.number.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  })),
};

DetailsCondition.defaultProps = {
  details: [],
}

export default withScopedTranslations('offer_details.details_condition')(DetailsCondition);
